/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ViewByOptionDTO { 
    /**
     * Human-readable label for the view option, such as ROAS or CPO.
     */
    label: string;
    /**
     * View type value used by MPO.
     */
    value: ViewByOptionDTO.ValueEnum;
}
export namespace ViewByOptionDTO {
    export type ValueEnum = 'ROAS' | 'CPO';
    export const ValueEnum = {
        Roas: 'ROAS' as ValueEnum,
        Cpo: 'CPO' as ValueEnum
    };
}


